import { useMemo } from "react";
import IDeal from "../interfaces/IDeal";
import Shape from "../interfaces/Shape";
import GeometryService from "../services/geometryService";

export default function (deals: IDeal[], shape: Shape | Shape[] | null): IDeal[] {
    const geometryService = useMemo(() => new GeometryService(), []);

    return useMemo(() => shape ? deals.filter(d => geometryService.isPointInsideShape({ latitude: d.lat, longitude: d.lon }, shape)) : deals, [deals, shape]);
}